export interface BycatchDef {
  id: string;
  name: string;
  category: 'junk' | 'useful' | 'treasure';
  value: number;
}

export const BYCATCH_ITEMS: BycatchDef[] = [
  // Junk (0.01–2 coins)
  { id: 'old_boot', name: 'Old Boot', category: 'junk', value: 0.1 },
  { id: 'seaweed', name: 'Seaweed', category: 'junk', value: 0.25 },
  { id: 'driftwood', name: 'Driftwood', category: 'junk', value: 0.01 },
  { id: 'rusty_can', name: 'Rusty Can', category: 'junk', value: 0.5 },
  { id: 'broken_net', name: 'Broken Net', category: 'junk', value: 1 },
  { id: 'empty_beer_crate', name: 'Empty Beer Crate', category: 'junk', value: 2 },
  // Useful (8–25 coins)
  { id: 'message_bottle', name: 'Message in a Bottle', category: 'useful', value: 10 },
  { id: 'fancy_shell', name: 'Fancy Shell', category: 'useful', value: 8 },
  { id: 'silver_locket', name: 'Silver Locket', category: 'useful', value: 15 },
  { id: 'ancient_coin', name: 'Ancient Coin', category: 'useful', value: 20 },
  { id: 'pearl', name: 'Pearl', category: 'useful', value: 25 },
  // Treasure (50–500 coins)
  { id: 'ancient_gold_coin', name: 'Ancient Gold Coin', category: 'treasure', value: 50 },
  { id: 'gold_ring', name: 'Gold Ring', category: 'treasure', value: 100 },
  { id: 'sapphire', name: 'Sapphire', category: 'treasure', value: 200 },
  { id: 'treasure_chest', name: 'Treasure Chest', category: 'treasure', value: 500 },
];

export function getBycatchById(id: string): BycatchDef | undefined {
  return BYCATCH_ITEMS.find(b => b.id === id);
}

export function rollForBycatch(locationBycatchChance: number): boolean {
  return Math.random() < locationBycatchChance;
}

export function getRandomBycatch(): BycatchDef {
  const roll = Math.random();
  let categoryWeights: { cat: 'junk' | 'useful' | 'treasure'; weight: number };
  if (roll < 0.60) {
    categoryWeights = { cat: 'junk', weight: 0 };
  } else if (roll < 0.90) {
    categoryWeights = { cat: 'useful', weight: 0 };
  } else {
    categoryWeights = { cat: 'treasure', weight: 0 };
  }
  const pool = BYCATCH_ITEMS.filter(b => b.category === categoryWeights.cat);
  return pool[Math.floor(Math.random() * pool.length)];
}
